import { FLOWS_ENUM } from './enums';
import { PAYMENT_CATEGORY } from '../types/payment';

export const getPaymentCategory = (
  flow: FLOWS_ENUM
): PAYMENT_CATEGORY | undefined => {
  switch (flow) {
    case FLOWS_ENUM.APPLY_LICENSE:
      return PAYMENT_CATEGORY.APPLICATION;
    case FLOWS_ENUM.RENEW_LICENSE:
    case FLOWS_ENUM.BULK_RENEWAL:
      return PAYMENT_CATEGORY.RENEWAL;
    case FLOWS_ENUM.PAY_TOT:
      return PAYMENT_CATEGORY.TOT;
    default:
      return undefined;
  }
};
